class AccountPanel extends Panel {
  transitionFrom(previousState, newState, triggerElement, previousPanel) {
    // super.transitionFrom(previousState, newState, triggerElement, previousPanel);
    this.activate();
    switch (previousState) {
      case 'idle':
        requestAnimationFrame(() => {
          this.animateDrawOpen().then(() => {
            window.trapFocus(this, this.defaultFocus, triggerElement);
            drawerElement.addEventListener('mouseover', mouseOverDrawer); // @todo - what is this?
          });
        });

        break;
      case 'shopActive':
        drawerElement.className =
          'drawer-inner absolute bottom-0 top-0 z-75 w-24 ' +
          'left-0 lg:left-auto lg:right-0 bg-white text-black ' +
          'transition-all duration-600 md:w-26';
        if (previousPanel) {
          previousPanel.deactivate();
        }
        break;
      case 'registerActive':
        window.releaseFocus();
        // window.trapFocus(this, this.defaultFocus, triggerElement);
        previousPanel.deactivate();
        break;
    }
  }

  animateDrawOpen() {
    return new Promise((resolve) => {
      console.log('openRightLeftNav');
      maskElement.show();
      drawerWrapperElement.style.zIndex = '100';
      // set start state
      drawerElement.className =
        'drawer-inner absolute bottom-0 top-0 z-75 w-24 ' +
        'left-0 lg:left-auto lg:right-0 -translate-x-full lg:translate-x-full bg-white text-black ' +
        'transition-all duration-600 md:w-26';
      // un-hide container
      drawerWrapperElement.classList.remove('hidden');
      // set transition state
      requestAnimationFrame(() => {
        drawerElement.classList.remove('lg:translate-x-full');
        drawerElement.classList.remove('-translate-x-full');
        maskElement.classList.replace('opacity-0', 'opacity-60');
        waitForTransitionEnd(drawerElement).then(() => {
          resolve();
        });
      });
    });
  }
}

customElements.define('account-panel', AccountPanel);
